// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest {
    static getAttributeTypeMap() {
        return ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest.attributeTypeMap;
    }
}
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest.discriminator = undefined;
ClaimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest.attributeTypeMap = [
    {
        "name": "start",
        "baseName": "start",
        "type": "number"
    },
    {
        "name": "pageSize",
        "baseName": "pageSize",
        "type": "number"
    },
    {
        "name": "searchModel",
        "baseName": "searchModel",
        "type": "ClaimSearchModel"
    },
    {
        "name": "filterByClaimGroup",
        "baseName": "filterByClaimGroup",
        "type": "boolean"
    }
];
//# sourceMappingURL=claimV1ClaimPharmacyClaimSearchPharmacyClaimSearchRequest.js.map